const paymentTermsMethod = paymentTerms => {
  const exceptions = ["00", "99", "89", "02", 0, 2, 99, 89];
  if (exceptions.includes(paymentTerms)) return `0 days`;
  return `${paymentTerms} days`;
};
export default paymentTermsMethod
